// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8701dc61","455":"6e209a12","977":"83aac2ce"}[chunkId] + ".chunk.js";
};